<template>
  <!-- Non-modal, bottom right (mockup "Party invite"); the next shows once answered -->
  <section class="v5-pi" role="dialog" aria-labelledby="v5-pi-h">
    <span class="v5-pi__k">{{ t('v5_ui_shell.matchmaking') }}</span>
    <h2 id="v5-pi-h">{{ t('v5_ui_shell.party_invite') }}</h2>
    <p>{{ t('v5_ui_shell.invited_you', { name: inviterName }) }}</p>
    <div class="v5-pi__acts">
      <button class="v5-btn" type="button" :disabled="responding" @click="respond('decline')">{{ t('v5_ui_shell.decline') }}</button>
      <button ref="acceptBtn" class="v5-btn-p" type="button" :disabled="responding" @click="respond('accept')">
        {{ responding ? t('v5_ui_shell.joining') : t('v5_ui_shell.accept') }}
      </button>
    </div>
    <p v-if="error" class="v5-pi__err v5-bad" role="alert">{{ error }}</p>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import usePartyInvite from '../../composables/usePartyInvite';

// A party invite: the classic answer flow (usePartyInvite).
const props = defineProps({
  invite: { type: Object, required: true },
});
const { t } = useI18n();
const {
  responding, error, inviterName, respond,
} = usePartyInvite(props);
</script>

<style>
.v5-pi { position: fixed; right: 16px; bottom: 16px; z-index: 50; display: grid; gap: 8px; width: min(320px, calc(100vw - 32px)); padding: 14px 16px; border: 1px solid var(--rule); border-radius: var(--r); background: var(--surface); color: var(--fg); box-shadow: 0 12px 32px color-mix(in oklab, #000, transparent 60%); }
.v5-pi__k { color: var(--fg-2); font-size: var(--t-xs); font-weight: 600; }
.v5-pi h2 { margin: -6px 0 0; font-size: var(--t-lg); font-weight: 600; }
.v5-pi p { margin: 0; color: var(--fg-2); }
.v5-pi__acts { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 4px; }
.v5-pi__acts > * { min-height: 40px; }
.v5-pi__err { font-size: var(--t-sm); }
@media (max-width: 44rem) { .v5-pi { left: 16px; width: auto; } .v5-pi__acts > * { min-height: 44px; } }
</style>
